import { render, staticRenderFns } from "./RegionalManagers.vue?vue&type=template&id=14e0e42a&"
import script from "./RegionalManagers.vue?vue&type=script&lang=js&"
export * from "./RegionalManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports